<template>
  <div>
    <v-btn
      class="ma-0 mb-5 ml-5"
      color="primary"
      @click="synchEventsRacketcamp()"
    >
      Synch Events.Racketcamp
    </v-btn>
    <add-room-modal
      title="+ Создать бронирование"
      @add-reservation="AddReservation"
    ></add-room-modal>
    <v-btn
      class="ma-0 mb-5 ml-5"
      color="success"
      @click="goServiceOnlyBooking()"
    >
      + Бронирование (только услуги)
    </v-btn>
    <v-btn
      class="ma-0 mb-5 ml-5"
      color="primary"
      @click="addBonusTransaction()"
    >
      Начислить бонусы
    </v-btn>
    <h1>{{ $store.getters.event.header }}</h1>
    <v-card id="account-setting-card">
      <!-- tabs -->
      <v-tabs
        v-model="tab"
        show-arrows
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.id"
          @click="getTabsData(tab)"
        >
          <v-icon
            size="20"
            class="me-3"
          >
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>
      <!-- tabs item -->
      <v-tabs-items v-model="tab">
        <v-tab-item :touch="false">
          <v-card>
            <v-data-table
              mobile-breakpoint="100"
              :headers="headers"
              :items="sortedReservationList"
              class="table-rounded elevation-1"
              :items-per-page="-1"
              hide-default-footer
              :loading="loading"
              loading-text="Загрузка данных"
              :item-class="reservationRowClass"
            >
              <template #[`item.id`]="{ item }">
                <div class="d-flex flex-column">
                  <router-link :to="'/events/' + item.event_id + '/' + item.uuid">
                    <span class="d-block font-weight-semibold">{{ item.id }}</span>
                  </router-link>
                  <v-chip
                    v-if="item.booking_status === 'cancelled'"
                    x-small
                    color="grey lighten-1"
                    class="mt-1 align-self-start"
                  >
                    Отменено
                  </v-chip>
                </div>
              </template>

              <template #[`item.user`]="{ item }">
                <div :class="{ reservation_confirm: item.confirm }">
                  {{ item.user.name }}
                </div>
              </template>

              <template #[`item.room`]="{ item }">
                <p
                  v-for="(dpt, index) in item.room"
                  :key="index"
                  class="mt-2"
                >
                  {{ dpt.name }} - №{{ dpt.room_number }}
                  <v-tooltip right>
                    <span>Страховка</span>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="dpt.insurance"
                        v-bind="attrs"
                        color="success"
                        v-on="on"
                      >
                        {{ icons.mdiShieldAccount }}
                      </v-icon>
                    </template>
                  </v-tooltip>
                  <v-tooltip right>
                    <span>Промокод {{ item.promocode }}</span>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="item.promocode"
                        v-bind="attrs"
                        color="success"
                        v-on="on"
                      >
                        {{ icons.mdiSale }}
                      </v-icon>
                    </template>
                  </v-tooltip>
                </p>
              </template>

              <!-- status -->
              <template #[`item.pay_status`]="{ item }">
                <v-chip
                  v-if="item.booking_status === 'cancelled'"
                  small
                  color="grey"
                  class="font-weight-medium"
                >
                  Отменено
                </v-chip>
                <v-chip
                  v-else-if="item.pay_price == item.pay_sum && item.pay_price != 0"
                  small
                  :color="statusColor[status[1]]"
                  class="font-weight-medium"
                >
                  {{ status[1] }}
                </v-chip>
                <span v-else-if="item.pay_price == 0">
                  {{ status[5] }}
                </span>
                <v-chip
                  v-else-if="item.pay_sum <= 0"
                  small
                  :color="statusColor[status[3]]"
                  class="font-weight-medium"
                >
                  {{ status[3] }}
                </v-chip>
                <v-chip
                  v-else-if="item.pay_price > item.pay_sum"
                  small
                  :color="statusColor[status[2]]"
                  class="font-weight-medium"
                >
                  {{ status[2] }}
                </v-chip>

                <v-chip
                  v-else-if="item.pay_sum > item.pay_price"
                  small
                  :color="statusColor[status[4]]"
                  class="font-weight-medium"
                >
                  {{ status[4] }}
                </v-chip>
              </template>

              <template #[`item.bonus_pay`]="{ item }">
                <div class="d-flex flex-column">
                  <span v-if="!bonusesLoading && !bonusesLoadError && bonusOpsTotals(item.uuid).expense > 0">
                    {{ formatBonusPoints(bonusOpsTotals(item.uuid).expense) }}
                  </span>
                </div>
              </template>

              <template #[`item.bonuses_accrued`]="{ item }">
                <div
                  v-if="bonusesLoading"
                  class="text-center"
                >
                  …
                </div>
                <div
                  v-else-if="bonusesLoadError"
                  class="text-center"
                >
                  —
                </div>
                <div
                  v-else
                  class="d-flex flex-column bonuses-ops-cell text-center"
                >
                  <span v-if="bonusOpsTotals(item.uuid).income > 0">{{ formatBonusPoints(bonusOpsTotals(item.uuid).income) }}</span>
                  <span v-else>Нет</span>
                </div>
              </template>

              <template #[`item.payment_method`]="{ item }">
                <div>
                  <span
                    v-if="item.warning"
                    :color="red"
                  >⚠️</span>
                  {{ payment_method_type[item.payment_method] }}
                </div>
              </template>

              <template slot="body.append">
                <tr>
                  <th>Totals</th>
                  <th>{{ reservationList.length }}</th>
                  <th></th>
                  <th>{{ sumField('pay_price') }}</th>
                  <th>{{ sumField('pay_sum') }}</th>
                  <th>{{ sumField('pay_debt') }}</th>
                  <th>
                    <div class="d-flex flex-column">
                      <span v-if="sumBonusesExpense > 0">{{ formatBonusPoints(sumBonusesExpense) }}</span>
                    </div>
                  </th>   
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </template>
            </v-data-table>
            <v-simple-table class="mt-4 expandable-summary-table">
              <thead>
                <tr>
                  <th class="text-left">
                    Тип оплаты
                  </th>
                  <th class="text-right">
                    Сумма
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(sum, method) in sumByPaymentMethod">
                  <tr
                    :key="'pm-' + method"
                    class="expandable-summary-table__toggle"
                    tabindex="0"
                    @click="togglePaymentMethod(method)"
                    @keydown.enter.prevent="togglePaymentMethod(method)"
                    @keydown.space.prevent="togglePaymentMethod(method)"
                  >
                    <td>
                      <div class="d-flex align-center">
                        <v-icon
                          small
                          class="expandable-summary-table__chevron me-2"
                        >
                          {{ expandedPaymentMethods[method] ? icons.mdiChevronDown : icons.mdiChevronRight }}
                        </v-icon>
                        {{ payment_method_type[method] }}
                      </div>
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(sum) }}
                    </td>
                  </tr>
                  <tr
                    v-show="expandedPaymentMethods[method]"
                    :key="'pm-d-' + method"
                    class="expandable-summary-table__detail-wrap"
                  >
                    <td
                      colspan="2"
                      class="pa-0"
                    >
                      <v-simple-table
                        dense
                        class="expandable-summary-table__nested"
                      >
                        <thead>
                          <tr>
                            <th class="text-left">
                              Номер брони
                            </th>
                            <th class="text-left">
                              ФИО клиента
                            </th>
                            <th class="text-right">
                              Сумма
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(row, idx) in (detailsByPaymentMethod[method] || [])"
                            :key="idx"
                          >
                            <td>
                              <router-link :to="'/events/' + row.event_id + '/' + row.uuid">
                                {{ row.reservationId }}
                              </router-link>
                            </td>
                            <td>{{ row.clientName }}</td>
                            <td class="text-right">
                              {{ formatCurrency(row.amount) }}
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
            <v-simple-table
              v-if="Object.keys(sumByCashRegisterTag).length > 0"
              class="mt-4 expandable-summary-table"
            >
              <thead>
                <tr>
                  <th class="text-left">
                    Тег кассы
                  </th>
                  <th class="text-right">
                    Сумма
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(sum, tag) in sumByCashRegisterTag">
                  <tr
                    :key="'crt-' + tag"
                    class="expandable-summary-table__toggle"
                    tabindex="0"
                    @click="toggleCashRegisterTag(tag)"
                    @keydown.enter.prevent="toggleCashRegisterTag(tag)"
                    @keydown.space.prevent="toggleCashRegisterTag(tag)"
                  >
                    <td>
                      <div class="d-flex align-center">
                        <v-icon
                          small
                          class="expandable-summary-table__chevron me-2"
                        >
                          {{ expandedCashRegisterTags[tag] ? icons.mdiChevronDown : icons.mdiChevronRight }}
                        </v-icon>
                        {{ tag }}
                      </div>
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(sum) }}
                    </td>
                  </tr>
                  <tr
                    v-show="expandedCashRegisterTags[tag]"
                    :key="'crt-d-' + tag"
                    class="expandable-summary-table__detail-wrap"
                  >
                    <td
                      colspan="2"
                      class="pa-0"
                    >
                      <v-simple-table
                        dense
                        class="expandable-summary-table__nested"
                      >
                        <thead>
                          <tr>
                            <th class="text-left">
                              Номер брони
                            </th>
                            <th class="text-left">
                              ФИО клиента
                            </th>
                            <th class="text-right">
                              Сумма
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(row, idx) in (detailsByCashRegisterTag[tag] || [])"
                            :key="idx"
                          >
                            <td>
                              <router-link :to="'/events/' + row.event_id + '/' + row.uuid">
                                {{ row.reservationId }}
                              </router-link>
                            </td>
                            <td>{{ row.clientName }}</td>
                            <td class="text-right">
                              {{ formatCurrency(row.amount) }}
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
            <v-simple-table
              v-if="Object.keys(promocodeCounts).length > 0"
              class="mt-4"
            >
              <thead>
                <tr>
                  <th class="text-left">
                    Промокод
                  </th>
                  <th class="text-right">
                    Количество применений
                  </th>
                  <th class="text-right">
                    Человеко-дней
                  </th>
                  <th class="text-left">
                    Участники
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(count, promocode) in promocodeCounts"
                  :key="promocode"
                >
                  <td>{{ promocode }}</td>
                  <td class="text-right">
                    {{ count }}
                  </td>
                  <td class="text-right">
                    {{ promocodeManDays[promocode] || 0 }}
                  </td>
                  <td>
                    <v-btn
                      small
                      text
                      color="primary"
                      @click="openPromocodeParticipantsModal(promocode)"
                    >
                      Показать ({{ (promocodeParticipants[promocode] || []).length }})
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-dialog
              v-model="promocodeParticipantsModal"
              max-width="600"
              persistent
            >
              <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                  Участники по промокоду «{{ selectedPromocode }}»
                </v-card-title>
                <v-card-text class="pt-4">
                  <v-simple-table v-if="modalParticipants.length > 0">
                    <thead>
                      <tr>
                        <th class="text-left">
                          Участник
                        </th>
                        <th class="text-left">
                          Начало
                        </th>
                        <th class="text-left">
                          Конец
                        </th>
                        <th class="text-right">
                          Дней
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="p in modalParticipants"
                        :key="p.id"
                      >
                        <td>{{ p.name }}</td>
                        <td>{{ p.start }}</td>
                        <td>{{ p.end }}</td>
                        <td class="text-right">
                          {{ p.days }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th
                          colspan="3"
                          class="text-left"
                        >
                          Итого человеко-дней
                        </th>
                        <th class="text-right">
                          {{ modalParticipantsTotalDays }}
                        </th>
                      </tr>
                    </tfoot>
                  </v-simple-table>
                  <p
                    v-else
                    class="text-center grey--text"
                  >
                    Нет данных об участниках
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="promocodeParticipantsModal = false"
                  >
                    Закрыть
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-tab-item>

        <v-tab-item :touch="false">
          <v-card>
            <v-progress-linear
              :active="loader"
              :indeterminate="loader"
            ></v-progress-linear>
            <v-simple-table
              mobile-breakpoint="100"
              height="80vh"
              fixed-header
            >
              <thead>
                <tr>
                  <th
                    width="450"
                    class="text-left p-0 m-0"
                  >
                    Номер
                  </th>
                  <th class="text-left">
                    <div class="d-flex">
                      <div
                        v-for="d in event_rooms_list.event_date"
                        :key="d"
                        class="range_object"
                      >
                        {{ d }}
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in event_rooms_list.rooms"
                  :key="item.id"
                >
                  <td>
                    <v-card-title
                      class="mx-0 px-0"
                      style="font-size: 13px"
                    >
                      <v-icon
                        v-if="item.status"
                        small
                        class="mr-2"
                        color="success"
                      >
                        {{ icons.mdiContactlessPaymentCircle }}
                      </v-icon>
                      {{ item.name }} №{{ item.room_number }}
                      <v-icon
                        class="ml-2"
                        small
                        dark
                        color="primary"
                        @click="getRoomData(item.id)"
                      >
                        {{ icons.mdiLeadPencil }}
                      </v-icon>
                    </v-card-title>
                    <v-card-subtitle
                      class="mx-0 px-0 mb-0 pb-0"
                      style="font-size: 10px"
                    >
                      {{ item.package }}
                    </v-card-subtitle>
                    <v-card-subtitle
                      class="mx-0 px-0 mb-0"
                      style="font-size: 10px"
                    >
                      <div>Тип бронирования: {{ item.order_room_type_name }}</div>
                      <div v-if="item.order_room_type == 1">
                        Пол номера: {{ item.gender_room_type_name }}
                      </div>
                    </v-card-subtitle>
                  </td>
                  <td :colspan="event_rooms_list.event_date.length + 1">
                    <div
                      v-for="reservation in item.reservation"
                      :key="reservation.id"
                      class="reservation_wrap"
                    >
                      <div class="reservation_block">
                        <div
                          class="reservation d-flex justify-space-between align-center"
                          :style="'width:' + reservation.width + '%; left:' + reservation.left + '%'"
                        >
                          <div>
                            {{ reservation.people_in_room.length }}
                            {{ reservation.name }}
                          </div>
                          <div>
                            <v-btn
                              icon
                              small
                              @click="reservation.show_people = !reservation.show_people"
                            >
                              <v-icon
                                small
                                color="white"
                              >
                                {{ icons.mdiEye }}
                              </v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              @click="getRoomListByEventIdAndRoomType(reservation)"
                            >
                              <v-icon
                                small
                                color="white"
                              >
                                {{ icons.mdiSwapHorizontal }}
                              </v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div
                        v-show="reservation.show_people"
                        class="reservation_people_wrap"
                      >
                        <div
                          v-for="p in reservation.people_in_room"
                          :key="p.id"
                          class="reservation_wrap"
                        >
                          <div class="reservation_block_item">
                            <div
                              class="reservation"
                              :style="'width:' + p.width + '%; left:' + p.left + '%'"
                            >
                              {{ p.name }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-tab-item>

        <!-- <v-tab-item :touch="false">
          <v-card>
            <v-progress-linear :active="loader" :indeterminate="loader"></v-progress-linear>
            <v-simple-table mobile-breakpoint="100" height="75vh" fixed-header>
              <thead>
                <tr>
                  <th class="text-left">Id</th>
                  <th class="text-left">Участник</th>
                  <th class="text-left">Телефон</th>
                  <th class="text-left">Даты</th>
                  <th class="text-left">Взрослый/Ребенок</th>
                  <th class="text-left">Возраст ребенка</th>
                  <th class="text-left">Вид спорта</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(people, idx) in event_people_list" :key="people.id">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ people.name }}</td>
                  <td>{{ people.phone }}</td>
                  <td>{{ people.start }} - {{ people.end }}</td>
                  <td>
                    <span v-if="people.age_type == 2">Ребенок</span>
                    <span v-else>Взрослый</span>
                  </td>
                  <td>
                    <span v-if="people.age_type == 2">{{ people.child_age }}</span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <v-select v-if="people.type == 1" v-model="people.sport" :items="people.sport_list" item-text="name"
                      item-value="value" label="Вид спорта" class="mt-5"
                      @change="changeEventPeopleSportType(people)"></v-select>
                    <span v-else> сопровождающий </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-tab-item> -->

        <v-tab-item :touch="false">
          <v-btn
            small
            color="primary"
            class="mb-3 mt-3 ml-3"
            @click="copyTableToClipboard"
          >
            Копировать таблицу
          </v-btn>
          <v-card>
            <v-progress-linear
              :active="loader"
              :indeterminate="loader"
            ></v-progress-linear>
            <v-simple-table
              mobile-breakpoint="100"
              height="75vh"
              fixed-header
            >
              <thead>
                <tr>
                  <th class="text-left">
                    Чат
                  </th>
                  <th class="text-left">
                    Номер участника
                  </th>
                  <th class="text-left">
                    Участник
                  </th>
                  <th class="text-left">
                    Номер телефона
                  </th>
                  <th class="text-left">
                    Спортсмен/Турист
                  </th>
                  <th class="text-left">
                    Тип участника
                  </th>
                  <th class="text-left">
                    Рейтинг
                  </th>
                  <th class="text-left">
                    Программа сборов
                  </th>
                  <th class="text-left">
                    Номер группы
                  </th>
                  <th class="text-left">
                    Вид спорта
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(people, idx) in event_people_data"
                  :key="people.id"
                >
                  <td>{{ people.chat }}</td>
                  <td>{{ idx + 1 }}</td>
                  <td>{{ people.name }}</td>
                  <td>{{ getPhoneForPeople(people.id) }}</td>
                  <td>{{ people.sport_name }}</td>
                  <td>{{ people.age_type }}</td>
                  <td>{{ people.rating }}</td>
                  <td>{{ people.dates }}</td>
                  <td>{{ people.group_number }}</td>
                  <td>
                    <v-select
                      v-if="people.type == 1"
                      v-model="people.sport"
                      :items="people.sport_list"
                      item-text="name"
                      item-value="value"
                      label="Вид спорта"
                      class="mt-5"
                      @change="changeEventPeopleSportType(people)"
                    ></v-select>
                    <span v-else> сопровождающий </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-tab-item>

        <v-tab-item :touch="false">
          <v-card>
            <v-progress-linear
              :active="loader"
              :indeterminate="loader"
            ></v-progress-linear>
            <v-simple-table
              mobile-breakpoint="100"
              height="75vh"
              fixed-header
            >
              <thead>
                <tr>
                  <th class="text-left">
                    Тренер
                  </th>
                  <th class="text-right">
                    Сумма/день
                  </th>
                  <th class="text-right">
                    Кол-во дней
                  </th>
                  <th class="text-right">
                    Общая выплата
                  </th>
                  <th class="text-left">
                    Промокод
                  </th>
                  <th class="text-left">
                    Статус отправки
                  </th>
                  <th class="text-left">
                    Статус ответа
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="offer in offers_list"
                  :key="offer.id"
                >
                  <td>
                    <router-link :to="'/events/' + $route.params.id + '/offer/' + offer.uuid">
                      <span>{{ offer.trainer_name }}</span>
                    </router-link>
                  </td>
                  <td class="text-right">
                    {{ offer.rate_per_day != null ? offer.rate_per_day.toLocaleString('ru-RU') + ' ₽' : '—' }}
                  </td>
                  <td class="text-right">
                    {{ offer.days_amount != null ? offer.days_amount : '—' }}
                  </td>
                  <td class="text-right">
                    {{ formatOfferPayout(offer) }}
                  </td>
                  <td>
                    {{ offer.promo_code_name || '—' }}
                  </td>
                  <td>
                    <template v-if="offer.sent">
                      Отправлено
                    </template>
                    <template v-else>
                      <v-btn
                        small
                        color="primary"
                        @click="sendOffer(offer.uuid)"
                      >
                        Отправлен
                      </v-btn>
                    </template>
                  </td>
                  <td>
                    <template v-if="offer.answered">
                      <template v-if="offer.accepted">
                        Согласовано
                      </template>
                      <template v-else>
                        Отказ
                      </template>
                    </template>
                    <template v-else>
                      Ответ не получен
                    </template>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <v-btn
                  small
                  class="ma-0 mb-5 ml-5 mt-10"
                  color="primary"
                  @click="new_offer_popup = true"
                >
                  + Добавить оффер
                </v-btn>
              </tfoot>
            </v-simple-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog
      v-model="racketcamp_dialog"
      persistent
      max-width="960"
    >
      <v-card>
        <v-card-title class="text-h6">
          Выгрузка расселения в Events.Racketcamp
        </v-card-title>
        <v-card-subtitle v-if="racketcamp_preview">
          {{ racketcamp_preview.event_name }}
          · UUID: {{ racketcamp_preview.racketcamp_uuid }}
          · {{ racketcamp_preview.people_count }} участник(ов)
        </v-card-subtitle>

        <v-card-text>
          <v-alert
            v-if="racketcamp_error"
            type="error"
            dense
            class="mb-3"
          >
            {{ racketcamp_error }}
          </v-alert>

          <v-alert
            v-for="(warning, idx) in racketcamp_preview && racketcamp_preview.warnings || []"
            :key="'warn-' + idx"
            type="warning"
            dense
            class="mb-2"
          >
            {{ warning }}
          </v-alert>

          <v-progress-linear
            v-if="racketcamp_loading"
            indeterminate
            color="primary"
            class="mb-3"
          />

          <v-data-table
            v-else-if="racketcamp_preview && racketcamp_preview.people && racketcamp_preview.people.length"
            :headers="racketcamp_headers"
            :items="racketcamp_preview.people"
            dense
            :items-per-page="-1"
            hide-default-footer
            class="elevation-1"
          >
            <template #[`item.missing_room_type_uuid`]="{ item }">
              <span
                v-if="item.missing_room_type_uuid"
                class="warning--text"
              >нет</span>
              <span v-else class="success--text">OK</span>
            </template>
          </v-data-table>

          <div
            v-else-if="racketcamp_preview && !racketcamp_loading"
            class="grey--text text--darken-1"
          >
            Список участников для выгрузки пуст.
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="racketcamp_sending"
            @click="closeRacketcampDialog"
          >
            Отмена
          </v-btn>
          <v-btn
            color="primary"
            :loading="racketcamp_sending"
            :disabled="racketcamp_loading || !racketcamp_preview || !racketcamp_preview.people_count"
            @click="confirmRacketcampSync"
          >
            Отправить в Racketcamp
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="new_reservation_popup"
      width="100%"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Выберете номер
        </v-card-title>

        <v-simple-table>
          <template v-if="free_event_rooms">
            <thead>
              <tr>
                <th class="text-left">
                  Id
                </th>
                <th>Номер</th>
                <th>Тип номера</th>
                <th>Пол номера</th>
                <th>Свободных мест</th>
                <th>Действие</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="suit in free_event_rooms"
                :key="suit.id"
              >
                <td>{{ suit.id }}</td>
                <td>{{ suit.name }} - {{ suit.room_number }}</td>
                <td>{{ suit.order_room_type_name }}</td>
                <td>{{ suit.gender_room_type_name }}</td>
                <td>{{ suit.free_places }}</td>
                <td>
                  <v-btn
                    x-small
                    color="success"
                    @click="changeRoom(suit.id)"
                  >
                    Перселить
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="new_offer_popup"
      persistent
      width="100%"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Создать новый оффер
        </v-card-title>
        <v-card-text>
          <template>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="trainer_name"
                :rules="trainer_nameRules"
                label="Имя"
                required
              ></v-text-field>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="offer_start_date_menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="offer_start_date"
                        label="Дата начала работы"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="offer_start_date"
                      locale="ru"
                      @input="offer_start_date_menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="offer_end_date_menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="offer_end_date"
                        label="Дата окончания работы"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="offer_end_date"
                      locale="ru"
                      :min="offer_start_date"
                      @input="offer_end_date_menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model.number="offer_rate_per_day"
                    label="Сумма в день (₽)"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model.number="offer_per_participant_per_day"
                    label="Сумма за привлечённого в день (₽)"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-select
                v-model="offer_promo_code_id"
                :items="offer_promo_codes_list"
                item-text="name"
                item-value="id"
                label="Промокод тренера"
                clearable
              ></v-select>

              <v-subheader class="pl-0 mt-2">
                Дополнительные выплаты
              </v-subheader>
              <div
                v-for="(extra, index) in offer_extra_payouts"
                :key="'offer-extra-' + index"
                class="mb-2"
              >
                <v-row dense align="center">
                  <v-col cols="12" sm="7">
                    <v-text-field
                      v-model="extra.description"
                      label="За что"
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model.number="extra.amount"
                      label="Сумма (₽)"
                      type="number"
                      min="0"
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-btn
                      small
                      text
                      color="error"
                      @click="removeOfferExtraPayout(index)"
                    >
                      Удалить
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-btn
                small
                color="secondary"
                class="mb-2"
                @click="addOfferExtraPayout"
              >
                + Добавить доп
              </v-btn>

              <v-textarea
                v-model="agreed_functionality"
                outlined
                :rules="agreed_functionalityRules"
                label="Функционал"
                required
              ></v-textarea>

              <v-textarea
                v-model="salary_description"
                outlined
                :rules="salary_descriptionRules"
                label="Условия оплаты"
                required
              ></v-textarea>
            </v-form>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title> Оффер </v-card-title>
        <v-card-text v-if="event_data">
          <template>
            <p>
              Здравствуйте, {{ trainer_name }}!<br />
              Вам направлено предложение принять участие на мероприятии в качестве тренера / члена команды
              организаторов.
            </p>

            <p>
              Ниже представлены подробные данные и условия сотрудничества. <br />
              Название мероприятия: <b>{{ event_data.name }}</b> <br />
              Даты работы: <b>{{ offer_start_date || event_data.start }} - {{ offer_end_date || event_data.end }}</b> <br />
              Расчетное количество рабочих дней: <b>{{ offerDays }}</b> <br />
              <template v-if="offer_rate_per_day">
                Ставка: <b>{{ offer_rate_per_day.toLocaleString('ru-RU') }} ₽/день</b><br />
              </template>
              <template v-if="offer_per_participant_per_day">
                Бонус за привлечённого участника: <b>{{ offer_per_participant_per_day.toLocaleString('ru-RU') }} ₽/чел-день</b><br />
              </template>
              <template v-if="offer_rate_per_day && offerDays">
                Базовая выплата: <b>{{ (offer_rate_per_day * offerDays).toLocaleString('ru-RU') }} ₽</b><br />
              </template>
              <template v-if="offerPreviewBonus != null">
                Бонус за привлечённых
                <span v-if="offerPreviewPromoName"> (промокод «{{ offerPreviewPromoName }}»: {{ offer_per_participant_per_day }} ₽ × {{ offerPreviewManDays }} чел-дней)</span>:
                <b>{{ offerPreviewBonus.toLocaleString('ru-RU') }} ₽</b><br />
              </template>
              <template v-for="(extra, index) in offerPreviewExtras">
                <span :key="'preview-extra-' + index">
                  Доп. выплата ({{ extra.description || 'без описания' }}):
                  <b>{{ extra.amount.toLocaleString('ru-RU') }} ₽</b><br />
                </span>
              </template>
              <template v-if="offerPreviewTotal != null">
                <span style="font-size: 1.1em">Итого к выплате: <b>{{ offerPreviewTotal.toLocaleString('ru-RU') }} ₽</b></span><br />
              </template>
            </p>
            <p>
              Согласованный функционал: <br />
              <span style="white-space: pre-line">{{ agreed_functionality }}</span>
            </p>
            <p>
              Условия оплаты: <br />
              <span style="white-space: pre-line">{{ salary_description }}</span>
            </p>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="addOffer"
          >
            добавить оффер
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            @click="reset"
          >
            отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiAccount,
  mdiAccountGroup,
  mdiAccountOutline,
  mdiBedKing,
  mdiCart,
  mdiChevronDown,
  mdiChevronRight,
  mdiContactlessPaymentCircle,
  mdiCurrencyRub,
  mdiDotsVertical,
  mdiEye,
  mdiFileDocument,
  mdiInformationOutline,
  mdiLeadPencil,
  mdiLockOpenOutline,
  mdiSale,
  mdiShieldAccount,
  mdiSquareEditOutline,
  mdiSwapHorizontal,
} from '@mdi/js'

import Api from '@/api/api'
import MyLoader from '@/components/MyLoader.vue'
import AddRoomModal from '@/views/events/AddRoomModal.vue'
import { ref } from 'vue'
import { Editor } from 'vuetify-markdown-editor'
import { mapActions } from 'vuex'

export default {
  components: { AddRoomModal, MyLoader, Editor },
  data() {
    return {
      tab: ref(''),
      event_data: null,
      reservationList: [],
      loading: true,
      loader: false,
      statusColor: {
        Оплачен: 'success',
        Частично: 'warning',
        Неоплачен: 'error',
        Переплата: 'error',
      },
      uuid_event: null,
      free_event_rooms: [],
      new_reservation_popup: false,
      racketcamp_dialog: false,
      racketcamp_preview: null,
      racketcamp_loading: false,
      racketcamp_sending: false,
      racketcamp_error: null,
      racketcamp_headers: [
        { text: '№', value: 'order', width: '50' },
        { text: 'Участник', value: 'participant_name' },
        { text: 'Имя в выгрузке', value: 'export_name' },
        { text: 'Тип номера', value: 'room_type' },
        { text: 'Номер', value: 'room_number' },
        { text: 'Заезд', value: 'start' },
        { text: 'Выезд', value: 'end' },
        { text: 'Питание', value: 'food_display' },
        { text: 'UUID типа', value: 'missing_room_type_uuid', sortable: false },
      ],
      headers: [
        {
          text: 'ID Заказа',
          value: 'id',
          align: 'start',
          width: '110',
        },
        { text: 'Пользователь', value: 'user' },
        { text: 'Номер', value: 'room' },
        { text: 'Сумма', value: 'pay_price' },
        { text: 'Оплачено', value: 'pay_sum' },
        { text: 'Остаток', value: 'pay_debt' },
        { text: 'Оплачено бонусами', value: 'bonus_pay' },
        { text: 'Начисление бонусов', value: 'bonuses_accrued', align: 'center', width: '140' },
        { text: 'Тип оплаты', value: 'payment_method' },
        { text: 'Статус', value: 'pay_status', align: 'left' },
      ],
      headers_rooms: [{ text: 'Номер', value: 'name', align: 'start' }],
      status: {
        1: 'Оплачен',
        2: 'Частично',
        3: 'Неоплачен',
        4: 'Переплата',
        5: '–',
      },
      payment_method_type: {
        1: 'Картой',
        2: 'Наличными',
        3: 'Личный счет',
        4: 'Смешанная',
        5: '–',
      },
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
        mdiCurrencyRub,
        mdiBedKing,
        mdiCart,
        mdiChevronDown,
        mdiChevronRight,
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiAccount,
        mdiAccountGroup,
        mdiEye,
        mdiSwapHorizontal,
        mdiLeadPencil,
        mdiContactlessPaymentCircle,
        mdiShieldAccount,
        mdiSale,
        mdiFileDocument,
      },
      event_rooms_list: Array,
      event_people_list: Array,
      event_people_data: Array,
      new_event_room_id: Intl,
      reservation_room_id: Intl,
      event_people_list_by_days: Array,

      new_offer_popup: false,
      valid: true,
      trainer_name: '',
      trainer_nameRules: [v => !!v || 'Имя обязательное поле'],

      // trainer_email: '',
      // trainer_emailRules: [v => !!v || 'E-mail обязательное поле', v => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
      agreed_functionality: '',
      agreed_functionalityRules: [v => !!v || 'Имя обязательное поле'],
      salary_description: '',
      salary_descriptionRules: [v => !!v || 'Имя обязательное поле'],
      offer_start_date: null,
      offer_end_date: null,
      offer_start_date_menu: false,
      offer_end_date_menu: false,
      offer_rate_per_day: null,
      offer_per_participant_per_day: null,
      offer_promo_code_id: null,
      offer_promo_codes_list: [],
      offer_extra_payouts: [],

      offers_list: [],
      renderConfig: {
        // Mermaid config
        mermaid: {
          theme: 'dark',
        },
      },
      promocodeParticipantsModal: false,
      selectedPromocode: null,
      expandedCashRegisterTags: {},
      expandedPaymentMethods: {},
      bonusesByReservationUuid: {},
      bonusesLoading: false,
      bonusesLoadError: false,
    }
  },
  computed: {
    sortedReservationList() {
      return this.reservationList
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
          const aCancelled = a.item.booking_status === 'cancelled' ? 1 : 0
          const bCancelled = b.item.booking_status === 'cancelled' ? 1 : 0
          if (aCancelled !== bCancelled) return aCancelled - bCancelled
          return a.index - b.index
        })
        .map(({ item }) => item)
    },
    sumBonusesIncome() {
      return Object.values(this.bonusesByReservationUuid).reduce((sum, row) => {
        const n = row && Number(row.income)
        return sum + (Number.isFinite(n) ? n : 0)
      }, 0)
    },
    sumBonusesExpense() {
      return Object.values(this.bonusesByReservationUuid).reduce((sum, row) => {
        const n = row && Number(row.expense)
        return sum + (Number.isFinite(n) ? n : 0)
      }, 0)
    },
    tabs() {
      return [
        { title: 'Бронирования', icon: mdiCart, id: 1 },
        { title: 'Расселение', icon: mdiBedKing, id: 2 },
        { title: 'Участники', icon: mdiAccountGroup, id: 3 },
        { title: 'Офферы', icon: mdiFileDocument, id: 4 },
        {
          title: 'Пакеты Мероприятия',
          icon: mdiAccountGroup,
          id: 5,
          to: 'packages',
        },
        {
          title: 'Каталог услуг',
          icon: mdiAccountGroup,
          id: 7,
          to: 'services',
        },
        {
          title: 'Обратная связь',
          icon: mdiAccountGroup,
          id: 6,
          to: `feedback/${this.uuid_event}`,
        },
      ]
    },
    offerDays() {
      if (this.offer_start_date && this.offer_end_date) {
        const start = new Date(this.offer_start_date)
        const end = new Date(this.offer_end_date)
        const diff = Math.round((end - start) / (1000 * 60 * 60 * 24))
        return diff >= 0 ? diff : null
      }
      return this.event_data ? this.event_data.days : null
    },
    offerPreviewPromoName() {
      if (!this.offer_promo_code_id) return null
      const promo = this.offer_promo_codes_list.find(p => p.id === this.offer_promo_code_id)
      return promo ? promo.name : null
    },
    offerPreviewManDays() {
      const name = this.offerPreviewPromoName
      if (!name) return 0
      return this.promocodeManDays[name] || 0
    },
    offerPreviewBase() {
      if (!this.offer_rate_per_day || !this.offerDays) return null
      return this.offer_rate_per_day * this.offerDays
    },
    offerPreviewBonus() {
      if (!this.offer_per_participant_per_day || !this.offer_promo_code_id) return null
      return this.offer_per_participant_per_day * this.offerPreviewManDays
    },
    offerPreviewExtras() {
      return this.sanitizeOfferExtraPayouts(this.offer_extra_payouts)
    },
    offerPreviewExtrasTotal() {
      return this.offerPreviewExtras.reduce((sum, item) => sum + item.amount, 0)
    },
    offerPreviewTotal() {
      const base = this.offerPreviewBase
      const bonus = this.offerPreviewBonus
      const hasExtras = this.offerPreviewExtras.length > 0
      if (base == null && bonus == null && !hasExtras) return null
      return (base || 0) + (bonus || 0) + this.offerPreviewExtrasTotal
    },
    sumByPaymentMethod() {
      const sums = {}
      this.reservationList.forEach(reservation => {
        const invoices = reservation.invoices || []
        invoices.forEach(inv => {
          if (!inv.pay) return
          const method = inv.payment_method ?? 5
          if (!sums[method]) {
            sums[method] = 0
          }
          const amount = inv.price || 0
          if (inv.payment_type === 1) {
            sums[method] += amount
          } else if (inv.payment_type === 2) {
            sums[method] -= amount
          }
        })
      })
      return sums
    },
    detailsByPaymentMethod() {
      const byMethod = {}
      this.reservationList.forEach(reservation => {
        const invoices = reservation.invoices || []
        invoices.forEach(inv => {
          if (!inv.pay) return
          const method = inv.payment_method ?? 5
          if (!byMethod[method]) {
            byMethod[method] = []
          }
          const amount = inv.price || 0
          let signedAmount = 0
          if (inv.payment_type === 1) {
            signedAmount = amount
          } else if (inv.payment_type === 2) {
            signedAmount = -amount
          }
          byMethod[method].push({
            reservationId: reservation.id,
            clientName: reservation.user?.name || '—',
            amount: signedAmount,
            uuid: reservation.uuid,
            event_id: reservation.event_id,
          })
        })
      })
      return byMethod
    },
    promocodeCounts() {
      const counts = {}
      this.reservationList.forEach(reservation => {
        if (reservation.promocode) {
          const code = reservation.promocode
          if (!counts[code]) {
            counts[code] = 0
          }
          counts[code] += 1
        }
      })
      return counts
    },
    promocodeManDays() {
      const manDays = {}
      this.reservationList.forEach(reservation => {
        if (reservation.promocode && reservation.participant_man_days) {
          const code = reservation.promocode
          const total = reservation.participant_man_days.total_man_days || 0
          manDays[code] = (manDays[code] || 0) + total
        }
      })
      return manDays
    },
    promocodeParticipants() {
      const byCode = {}
      this.reservationList.forEach(reservation => {
        if (reservation.promocode && reservation.participant_man_days?.participants?.length) {
          const code = reservation.promocode
          if (!byCode[code]) byCode[code] = []
          byCode[code].push(...reservation.participant_man_days.participants)
        }
      })
      return byCode
    },
    modalParticipants() {
      if (!this.selectedPromocode) return []
      return this.promocodeParticipants[this.selectedPromocode] || []
    },
    modalParticipantsTotalDays() {
      return this.modalParticipants.reduce((sum, p) => sum + (p.days || 0), 0)
    },
    sumByCashRegisterTag() {
      const sums = {}
      this.reservationList.forEach(reservation => {
        const invoices = reservation.invoices || []
        invoices.forEach(inv => {
          if (!inv.pay) return
          const tag = inv.cash_register_tag || '—'
          if (!sums[tag]) {
            sums[tag] = 0
          }
          const amount = inv.price || 0
          if (inv.payment_type === 1) {
            sums[tag] += amount
          } else if (inv.payment_type === 2) {
            sums[tag] -= amount
          }
        })
      })
      return sums
    },
    detailsByCashRegisterTag() {
      const byTag = {}
      this.reservationList.forEach(reservation => {
        const invoices = reservation.invoices || []
        invoices.forEach(inv => {
          if (!inv.pay) return
          const tag = inv.cash_register_tag || '—'
          if (!byTag[tag]) {
            byTag[tag] = []
          }
          const amount = inv.price || 0
          let signedAmount = 0
          if (inv.payment_type === 1) {
            signedAmount = amount
          } else if (inv.payment_type === 2) {
            signedAmount = -amount
          }
          byTag[tag].push({
            reservationId: reservation.id,
            clientName: reservation.user?.name || '—',
            amount: signedAmount,
            uuid: reservation.uuid,
            event_id: reservation.event_id,
          })
        })
      })
      return byTag
    },
  },
  async created() {
    this.$watch(() => this.$route.params)
  },
  async mounted() {
    this.getEventDataById()
    this.getEventById()
    this.getTrainerOffer()
    this.getPromocodesForEvent()
  },
  methods: {
    formatOfferPayout(offer) {
      if (offer.total_payout != null) {
        return offer.total_payout.toLocaleString('ru-RU') + ' ₽'
      }
      const base = offer.rate_per_day != null && offer.days_amount != null
        ? offer.rate_per_day * offer.days_amount
        : null
      const bonus = offer.bonus_payout
      const extra = offer.extra_payout_total
      if (base == null && bonus == null && extra == null) return '—'
      return ((base || 0) + (bonus || 0) + (extra || 0)).toLocaleString('ru-RU') + ' ₽'
    },
    sanitizeOfferExtraPayouts(list) {
      return (list || [])
        .map(item => ({
          description: (item.description || '').trim(),
          amount: item.amount != null && item.amount !== '' ? Number(item.amount) : null,
        }))
        .filter(item => item.amount != null && Number.isFinite(item.amount))
    },
    addOfferExtraPayout() {
      this.offer_extra_payouts.push({ description: '', amount: null })
    },
    removeOfferExtraPayout(index) {
      this.offer_extra_payouts.splice(index, 1)
    },
    reservationRowClass(item) {
      return item.booking_status === 'cancelled' ? 'reservation-cancelled' : ''
    },
    getEventDataById() {
      try {
        Api.getEventDataById(parseInt(this.$route.params.id)).then(event => {
          this.$set(this, 'event_data', event)
          this.$set(this, 'uuid_event', event.uuid)
          this.$set(this, 'offer_start_date', event.start_date)
          this.$set(this, 'offer_end_date', event.end_date)
        })
      } catch (error) { }
    },
    getEventById() {
      try {
        Api.getReservationListByEventId({
          event_id: parseInt(this.$route.params.id),
        }).then(async event => {
          this.$set(this, 'reservationList', event)
          this.$set(this, 'loading', false)
          const uuids = (event || []).map(r => r.uuid).filter(Boolean)
          await this.fetchBonusesForReservationUuids(uuids)
        })
      } catch (error) { }
    },
    openPromocodeParticipantsModal(promocode) {
      this.selectedPromocode = promocode
      this.promocodeParticipantsModal = true
    },
    toggleCashRegisterTag(tag) {
      const next = !this.expandedCashRegisterTags[tag]
      this.$set(this.expandedCashRegisterTags, tag, next)
    },
    togglePaymentMethod(method) {
      const next = !this.expandedPaymentMethods[method]
      this.$set(this.expandedPaymentMethods, method, next)
    },
    getRoomForEvents() {
      try {
        this.loader = true
        Api.getRoomForEvents({
          event_id: parseInt(this.$route.params.id),
        }).then(event => {
          this.$set(this, 'event_rooms_list', event)
          this.$set(this, 'loader', false)
        })
      } catch (error) {
        this.loader = false
      }
    },
    getEventPeopleList() {
      try {
        this.loader = true
        Api.getEventPeopleList({
          event_id: parseInt(this.$route.params.id),
        }).then(event => {
          this.$set(this, 'event_people_list', event)
          this.$set(this, 'loader', false)
        })
      } catch (error) {
        this.loader = false
      }
    },
    getEventPeopleData() {
      try {
        this.loader = true
        Api.getEventPeopleData({
          event_id: parseInt(this.$route.params.id),
        }).then(event => {
          this.$set(this, 'event_people_data', event)
          this.$set(this, 'loader', false)
        })
      } catch (error) {
        this.loader = false
      }
    },
    getEventPeopleByDays() {
      try {
        this.loader = true
        Api.getEventPeopleByDays({
          event_id: parseInt(this.$route.params.id),
        }).then(event => {
          this.$set(this, 'event_people_list_by_days', event)
          this.$set(this, 'loader', false)
        })
      } catch (error) {
        this.loader = false
      }
    },
    changeEventPeopleSportType(event_people) {
      try {
        this.loader = true
        Api.changeEventPeopleSportType({
          event_people_id: event_people.id,
          kind_of_sport: event_people.sport,
        }).then(event => {
          this.getEventPeopleList()
        })
      } catch (error) {
        this.loader = false
      }
    },
    ...mapActions(['addReservationData']),
    async AddReservation(event_room_id) {
      try {
        Api.AddReservation({
          event_room_id,
        }).then(event => {
          if (event.reservation_uuid) {
            this.addReservationData(event)
            this.$router.push({
              path: `/events/${this.$route.params.id}/new`,
              replace: true,
            })
          }
        })
      } catch (error) {
        this.loader = false
      }
    },
    goServiceOnlyBooking() {
      this.$router.push({
        path: `/events/${this.$route.params.id}/new`,
        query: { mode: 'services' },
      })
    },
    async getTabsData(tab) {
      console.log(tab.to)
      if (tab.to) {
        this.$router.push({
          path: `/events/${this.$route.params.id}/${tab.to}`,
          replace: true,
        })
      }

      if (tab.id == 2) {
        this.event_rooms_list = []
        this.getRoomForEvents()
      }

      if (tab.id == 3) {
        this.event_people_list = []
        this.getEventPeopleList()
        this.getEventPeopleData()
        this.getEventPeopleByDays()
      }
    },
    getRoomListByEventIdAndRoomType(reservation_data) {
      this.reservation_room_id = reservation_data.event_room_reservation_id
      try {
        Api.getRoomListByEventIdAndRoomType({
          event_id: parseInt(this.$route.params.id),
          event_room_id: reservation_data.room_id,
        }).then(event => {
          this.$set(this, 'free_event_rooms', event)
          this.$set(this, 'new_reservation_popup', true)
        })
      } catch (error) { }
    },
    changeRoom(suit_id) {
      this.new_event_room_id = suit_id
      this.new_reservation_popup = false

      Api.resettleAdmin({
        reservation_room_id: this.reservation_room_id,
        new_room_id: this.new_event_room_id,
      }).then(event => {
        this.getRoomForEvents()
      })
    },
    getRoomData(roomId) {
      window.open(`https://lk.xbadm.ru/admin/events_app/eventroom/${roomId}/change/`, '_blank')
    },
    synchEventsRacketcamp() {
      this.racketcamp_error = null
      this.racketcamp_preview = null
      this.racketcamp_dialog = true
      this.racketcamp_loading = true

      Api.synchEventsRacketcamp({
        event_id: parseInt(this.$route.params.id),
        confirm: false,
      })
        .then(preview => {
          this.racketcamp_preview = preview
        })
        .catch(err => {
          this.racketcamp_error = (
            err.response
            && err.response.data
            && (err.response.data.error || err.response.data.detail)
          ) || 'Не удалось сформировать список для выгрузки'
        })
        .finally(() => {
          this.racketcamp_loading = false
        })
    },
    closeRacketcampDialog() {
      this.racketcamp_dialog = false
      this.racketcamp_preview = null
      this.racketcamp_error = null
      this.racketcamp_sending = false
    },
    confirmRacketcampSync() {
      this.racketcamp_sending = true
      this.racketcamp_error = null

      Api.synchEventsRacketcamp({
        event_id: parseInt(this.$route.params.id),
        confirm: true,
      })
        .then(() => {
          this.closeRacketcampDialog()
        })
        .catch(err => {
          this.racketcamp_error = (
            err.response
            && err.response.data
            && (err.response.data.error || err.response.data.detail)
          ) || 'Не удалось отправить данные в Events.Racketcamp'
        })
        .finally(() => {
          this.racketcamp_sending = false
        })
    },
    addBonusTransaction() {
      this.loader = true
      Api.addBonusTransaction({
        event_id: parseInt(this.$route.params.id),
      }).then(async event => {
        console.log(event)
        this.loader = false
        const uuids = (this.reservationList || []).map(r => r.uuid).filter(Boolean)
        await this.fetchBonusesForReservationUuids(uuids)
      })
    },
    addOffer() {
      if (this.valid) {
        this.loader = true
        const days = this.offerDays
        Api.addTrainerOffer({
          event_id: parseInt(this.$route.params.id),
          agreed_functionality: this.agreed_functionality,
          salary_description: this.salary_description,
          trainer_name: this.trainer_name,
          start_date: this.offer_start_date || null,
          end_date: this.offer_end_date || null,
          days_amount: days || null,
          rate_per_day: this.offer_rate_per_day || null,
          per_participant_per_day: this.offer_per_participant_per_day || null,
          promo_code_id: this.offer_promo_code_id || null,
          extra_payouts: this.sanitizeOfferExtraPayouts(this.offer_extra_payouts),
        }).then(event => {
          this.loader = false
          this.reset()
          this.$router.push({
            path: `/events/${this.$route.params.id}/offer/${event.uuid}`,
            replace: true,
          })
        })
      }
    },
    openOffer() { },
    sendOffer(uuid) {
      this.loader = true
      Api.sendTrainerOffer({
        uuid,
      }).then(event => {
        this.getTrainerOffer()
        this.loader = false
      })
    },
    copyTableToClipboard() {
      const headers = [
        'Чат',
        'Номер участника',
        'Участник',
        'Спортсмен/Турист',
        'Тип участника',
        'Рейтинг',
        'Программа сборов',
        'Номер группы',
      ]

      const rows = this.event_people_data.map((person, idx) => [
        person.chat,
        idx + 1,
        person.name,
        person.sport,
        person.age_type,
        person.rating,
        person.dates,
        person.group_number,
      ])

      const table = [headers, ...rows]
        .map(row => row.join('\t')) // используем табы для Excel/Sheets
        .join('\n')

      navigator.clipboard.writeText(table)
        .then(() => {
          this.$toast?.success?.('Таблица скопирована!') || alert('Таблица скопирована!')
        })
        .catch(err => {
          console.error('Ошибка при копировании:', err)
          alert('Не удалось скопировать таблицу')
        })
    },
    getTrainerOffer() {
      const params = new URLSearchParams([['event_id', parseInt(this.$route.params.id)]])
      Api.getTrainerOffer({ params }).then(event => {
        console.log(event)
        this.offers_list = event
      })
    },
    getPromocodesForEvent() {
      Api.getPromocodes({ event_id: parseInt(this.$route.params.id) }).then(data => {
        this.offer_promo_codes_list = Array.isArray(data) ? data : []
      })
    },
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
      this.new_offer_popup = false
      this.offer_start_date = null
      this.offer_end_date = null
      this.offer_rate_per_day = null
      this.offer_per_participant_per_day = null
      this.offer_promo_code_id = null
      this.offer_extra_payouts = []
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    sumField(key) {
      // sum data in give key (property)
      return this.reservationList.reduce((a, b) => a + (b[key] || 0), 0)
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value)
    },
    formatBonusPoints(value) {
      return new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value)
    },
    bonusOpsTotals(uuid) {
      const empty = { income: 0, expense: 0 }
      if (!uuid) return empty
      const row = this.bonusesByReservationUuid[uuid]
      if (!row || typeof row !== 'object') return empty
      const income = Number(row.income)
      const expense = Number(row.expense)
      return {
        income: Number.isFinite(income) ? income : 0,
        expense: Number.isFinite(expense) ? expense : 0,
      }
    },
    transactionBonusDirection(row) {
      if (row.isIncome === true) return 'income'
      if (row.isIncome === false) return 'expense'
      if (row.type === 'Начисление') return 'income'
      if (row.type === 'Списание') return 'expense'
      return null
    },
    ensureBonusBucket(map, uuid) {
      if (!map[uuid]) {
        map[uuid] = { income: 0, expense: 0 }
      }
      return map[uuid]
    },
    normalizeBonusesTransactionResponse(raw) {
      const map = {}
      if (raw == null) return map

      let list = raw
      if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
        if (Array.isArray(raw.data)) list = raw.data
        else if (Array.isArray(raw.results)) list = raw.results
        else if (Array.isArray(raw.transactions)) list = raw.transactions
        else {
          for (const [k, v] of Object.entries(raw)) {
            if (k === 'data' || k === 'results' || k === 'transactions' || k === 'message' || k === 'status') {
              continue
            }
            const n = Number(v)
            if (Number.isFinite(n) && typeof k === 'string' && k.length > 20) {
              const b = this.ensureBonusBucket(map, k)
              b.income += n
            }
          }
          return map
        }
      }

      if (!Array.isArray(list)) return map

      for (const row of list) {
        if (!row || typeof row !== 'object') continue
        const uuid =
          row.reservation_uuid ||
          row.reservationUuid ||
          row.user_reservation_uuid ||
          (typeof row.uuid === 'string' && row.uuid.includes('-') ? row.uuid : null)
        const amount = Math.abs(
          Number(
            row.amount ??
              row.bonus_amount ??
              row.bonuses_amount ??
              row.total ??
              row.accrued ??
              0,
          ),
        )
        const direction = this.transactionBonusDirection(row)
        if (!uuid || !Number.isFinite(amount) || amount <= 0 || !direction) continue
        const bucket = this.ensureBonusBucket(map, uuid)
        bucket[direction] += amount
      }
      return map
    },
    async fetchBonusesForReservationUuids(uuids) {
      const unique = [...new Set((uuids || []).filter(Boolean))]
      if (!unique.length) {
        this.$set(this, 'bonusesByReservationUuid', {})
        return
      }
      this.bonusesLoading = true
      this.bonusesLoadError = false
      try {
        const raw = await Api.getBonusesTransactionByReservationUuids(unique)
        const nextMap = this.normalizeBonusesTransactionResponse(raw)
        this.$set(this, 'bonusesByReservationUuid', nextMap)
      } catch (e) {
        this.bonusesLoadError = true
        this.$set(this, 'bonusesByReservationUuid', {})
      } finally {
        this.bonusesLoading = false
      }
    },
    getPhoneForPeople(peopleId) {
      if (!this.event_people_list || !Array.isArray(this.event_people_list)) {
        return ''
      }
      const person = this.event_people_list.find(p => p.id === peopleId)
      return person ? person.phone || '' : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.range_object {
  flex: 1;
  border-left: 1px solid rgb(186, 186, 186);
  text-align: center;
  font-size: 10px;
  padding: 10px 0;

  &:first-child {
    border-left: none;
  }
}

.people_in_room_block {
  margin-top: 3px;
  background-color: #6b36cb !important;
  color: #fff;
}

.reservation_wrap {
  padding: 10px 0;
}

.reservation_block {
  position: relative;
  min-height: 30px;
}

.reservation_people_wrap {
  margin-top: 10px;

  .reservation_wrap {
    padding: 0;
    margin-bottom: 5px;
  }
}

.expandable-summary-table__toggle {
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.expandable-summary-table__chevron {
  flex-shrink: 0;
  opacity: 0.65;
}

.expandable-summary-table__detail-wrap > td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.expandable-summary-table__nested {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

.reservation_block_item {
  position: relative;
  min-height: 25px;

  .reservation {
    position: absolute;
    background-color: #673bb8;
    color: #fff;
    border-radius: 20px;
    padding: 2px 10px;
    font-size: 13px;
  }
}

.reservation {
  position: absolute;
  background-color: #9155fd;
  color: #fff;
  border-radius: 20px;
  padding: 0px 10px;
  font-size: 13px;
}

.reservation_confirm {
  font-weight: bold;
}

::v-deep tr.reservation-cancelled {
  opacity: 0.55;
  background-color: #f5f5f5 !important;
}
</style>
